import { business } from '../data/products'
import { Mark } from './Header'

export function Footer() {
  const whatsappUrl = 'https:' + '//wa.me/' + business.whatsapp
  return (
    <footer>
      <div className="container footer-grid">
        <div>
          <a className="brand brand-light" href="#top"><Mark /><span><strong>ALSHIFAA</strong><small>PURE HONEY</small></span></a>
          <p>Pure honey. Nothing else.</p>
        </div>
        <div><h3>Contact</h3><a href={whatsappUrl}>+{business.whatsapp}</a><a href={`mailto:${business.email}`}>{business.email}</a></div>
        <div><h3>Explore</h3><a href="#story">Our Story</a><a href="#quality">Why Alshifaa</a><a href="#order">Order</a></div>
      </div>
      <div className="container footer-bottom"><span>© {new Date().getFullYear()} Alshifaa Honey</span><span>Pure honey only.</span></div>
    </footer>
  )
}
